import { render, staticRenderFns } from "./PhotoshopOnboardingSteps.vue?vue&type=template&id=6eed5e78"
import script from "./PhotoshopOnboardingSteps.vue?vue&type=script&lang=ts"
export * from "./PhotoshopOnboardingSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports